import { render, staticRenderFns } from "./PmToDosList.vue?vue&type=template&id=412b1a2f&scoped=true&"
import script from "./PmToDosList.vue?vue&type=script&lang=ts&"
export * from "./PmToDosList.vue?vue&type=script&lang=ts&"
import style0 from "./PmToDosList.vue?vue&type=style&index=0&id=412b1a2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412b1a2f",
  null
  
)

export default component.exports